<template>
  <profile-layout :spring-desktop-size="100">
    <template #content>
      <div :class="$style.content">
        <aw-spring :desktop-size="10">
          <lv-heading
            v-if="isEcomUser"
            level="2"
            tag="h2"
            version2
            :class="$style.title"
          >
            {{ $awt('aw.loyalty_layout.title') }}
          </lv-heading>

          <div :class="$style.container">
            <aw-cms-page-sidebar-wrapper
              v-if="isEcomUser"
              :menu-items="menuItems"
              :selected-item="currentItem"
            >
              <template #content>
                <nuxt-page />
              </template>
            </aw-cms-page-sidebar-wrapper>
            <aw-profile-empty v-else />
          </div>
          <template v-if="showBottomBlock">
            <aw-separator margin-top="md" margin-bottom="md" />
            <aw-ok-auchan-mobile-app />
          </template>
        </aw-spring>
      </div>
    </template>
  </profile-layout>
</template>

<script>
  import { useRoute } from 'nuxt/app';
  import ProfileLayout from '~~/shop/app/layouts/profile';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import { URL_PREFIX_WITHOUT_SLASH } from '~~/common/config/UrlConfig';
  import AwSpring from '~~/common/components/AwSpring';
  import AwSeparator from '~~/common/components/Common/AwSeparator';
  import AwOkAuchanMobileApp from '~~/common/components/AwOkAuchanMobileApp';
  import AwCmsPageSidebarWrapper from '~~/common/components/Page/Content/Wrapper/Sidebar/AwCmsPageSidebarWrapper';
  import AwProfileEmpty from '~~/common/components/Common/AwProfileEmpty.vue';
  import { mapState } from 'pinia';
  import { useUserStore } from '~~/common/stores/user';
  import { useLoyaltyCardStore } from '~~/shop/app/stores/loyaltyCard.js';

  export default {
    name: 'LoyaltyLayout',
    components: {
      AwOkAuchanMobileApp,
      AwSeparator,
      AwSpring,
      ProfileLayout,
      LvHeading,
      AwCmsPageSidebarWrapper,
      AwProfileEmpty,
    },
    computed: {
      ...mapState(useLoyaltyCardStore, {
        showBottomBlock: state => state.visibleBottomBlock,
      }),
      menuItems () {
        return [
          {
            id: 'aw.loyalty_layout.menu.loyalty_program',
            name: this.$awt('aw.loyalty_layout.menu.loyalty_program'),
            link: 'profile-loyalty-program',
          },
          {
            id: 'aw.loyalty_layout.menu.loyalty_card',
            name: this.$awt('aw.loyalty_layout.menu.loyalty_card'),
            link: 'profile-loyalty-card',
          },
          {
            id: 'aw.loyalty_layout.menu.coupons',
            name: this.$awt('aw.loyalty_layout.menu.coupons'),
            link: 'profile-loyalty-card-coupons',
          },
          {
            id: 'aw.loyalty_layout.menu.stickers',
            name: this.$awt('aw.loyalty_layout.menu.stickers'),
            link: 'profile-loyalty-card-stickers',
          },
          {
            id: 'aw.loyalty_layout.menu.partner_program',
            name: this.$awt('aw.loyalty_layout.menu.partner_program'),
            link: 'profile-loyalty-card-partner-program',
          },
          {
            id: 'aw.loyalty_layout.menu.transactions',
            name: this.$awt('aw.loyalty_layout.menu.transactions'),
            link: 'profile-loyalty-card-transactions',
          },
        ].filter(item => item)
          .map(p => ({
            ...p,
            link: this.$localePath(URL_PREFIX_WITHOUT_SLASH + '-' + p.link),
          }));
      },
      currentItem () {
        return this.menuItems.find(item => this.isActive(item));
      },
      ...mapState(useUserStore, {
        isEcomUser: state => state.isEcomUser,
      }),
    },
    methods: {
      isActive (menu) {
        const route = useRoute();
        return route.path === menu.link;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.title {
  padding-bottom: 20px;
  padding-left: 16px;
  @include tablet(min) {
    padding-bottom: 40px;
  }
}

.content {
  margin-bottom: 40px;

  @include tablet(min) {
    margin-bottom: 80px;
  }
}


.arrowRightIcon {
  @include desktop-small(max) {
    display: none;
  }
}

.container {
  .list {
    display: grid;
    margin: 0;
    padding: 20px 16px;
    border-radius: 16px;
    background: $color-background-3;
    grid-area: list;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 16px;

    @include tablet(min) {
      padding: 24px;
    }

    @include desktop-small(min) {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(4, auto);
    }

    &Item {
      height: max-content;
      padding: 12px;
      list-style: none;
      color: $color-text-primary;
      border-radius: 12px;
      background: $color-background-1;

      &Active {
        color: $color-text-inverse;
        background: $color-strawberry-450;
      }

      a {
        display: grid;
        gap: 12px;
        grid-template-columns: auto;
        align-items: center;
        text-decoration: none !important;

        @include tablet(min) {
          grid-template-columns: 32px auto;
        }
        @include desktop-medium(min) {
          grid-template-columns: 32px auto 16px;
        }
      }

      .icon {
        display: none;
        @include tablet(min) {
          display: block;
          width: 32px;
          height: 32px;
          padding: 8px;
          border-radius: 8px;
          background: $color-button-pressed-dark-bg;
        }
      }

      .name {
        font-size: 12px;
        font-weight: $font-weight-medium-v2;
        line-height: 16px;
        flex-grow: 1;
        word-break: break-word;

        @include desktop-small(min) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}

</style>
